import { setActiveView, setEditingPriority } from '..'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectActiveView } from '../selectors'
import { IBusinessPriority } from '../types'

export const useBusinessPrioritiesView = () => {
  const dispatch = useAppDispatch()
  const activeView = useSelector(selectActiveView)

  const goToList = useCallback(() => {
    dispatch(setEditingPriority(null))
    dispatch(setActiveView('list'))
  }, [dispatch])

  const goToEditView = useCallback(
    (item?: IBusinessPriority) => {
      dispatch(setEditingPriority(item ? item.uid : null))
      dispatch(setActiveView('edit'))
    },
    [dispatch]
  )

  return {
    activeView,
    goToList,
    goToEditView,
  }
}
